var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11C10.2909 11 8.5 9.20914 8.5 7C8.5 4.79086 10.2909 3 12.5 3C14.7091 3 16.5 4.79086 16.5 7C16.5 9.20914 14.7091 11 12.5 11Z",
    fill: "#FFCACA",
    stroke: "#FFCACA",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16.9348C5.5 16.0744 6.04085 15.3069 6.85109 15.0176C10.504 13.7129 14.496 13.7129 18.1489 15.0176C18.9591 15.3069 19.5 16.0744 19.5 16.9348V18.2503C19.5 19.4377 18.4483 20.3499 17.2728 20.1819L16.3184 20.0456C13.7856 19.6838 11.2144 19.6838 8.68162 20.0456L7.72721 20.1819C6.5517 20.3499 5.5 19.4377 5.5 18.2503V16.9348Z",
    fill: "#FFCACA",
    stroke: "#FFCACA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRed);
export default __webpack_public_path__ + "static/media/UserRed.5f55c2e88020ea596bfb5a5dfb4f0f08.svg";
export { ForwardRef as ReactComponent };